import { useMemo } from "react";
import useAuth from "../useAuth";
import { useGetDealerFirmLockStatusQuery } from "../../store/dealerRoles/firmApi";

// Kilit durumu kısa ömürlü (işlem birkaç saniye–dakika sürer) — 4 sn'de bir
// okunur. Sekme arka plandaysa RTK polling'i durdurmaz; istek hafif (Redis
// MGET), sorun değil.
const POLL_MS = 4000;

/**
 * FİRMA MEŞGULİYETİ (#303) — verilen firmalardan kilidi tutulanlar.
 *
 * Bir firmada kota/cihaz işlemi sürerken (Redis `distributeFirmQuotas<id>`
 * kilidi) aynı firmaya ikinci işlem yapılamaz. Panel bunu yalnız işlemi
 * başlatan ekranda değil, firmanın göründüğü HER sayfada "İşlem sürüyor"
 * rozeti ve kilitli butonlarla gösterir.
 *
 * Yalnız bayi panelinde çalışır; diğer rollerde boş küme döner.
 *
 * @param {string[]} firmIds
 * @returns {{ busyIds: Set<string>, isBusy: (id) => boolean }}
 */
export default function useFirmBusy(firmIds = []) {
  const { auth } = useAuth();
  const isDealer = auth?.role === "dealer";
  const ids = useMemo(
    () => [...new Set((firmIds || []).filter(Boolean).map(String))].sort(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(firmIds)]
  );

  const { data } = useGetDealerFirmLockStatusQuery(
    { token: auth?.accessToken, firmIds: ids },
    {
      skip: !isDealer || !auth?.accessToken || ids.length === 0,
      pollingInterval: POLL_MS,
    }
  );

  const busyIds = useMemo(
    () => new Set((data?.data?.busyFirmIds || []).map(String)),
    [data]
  );
  return { busyIds, isBusy: (id) => busyIds.has(String(id)) };
}
